// Adds abortable and aborts functions to all Restangularized Elements globally
// usage examples:
// Restangular.one('route1').abortable().get() => returns AbortablePromise
// Restangular.all('route3').abortable().put() => returns AbortablePromise
// AprimaRestangular.get().one('route2').abortable(abortablePromise1).get() => aborts abortablePromise1, returns AbortablePromise
// Restangular.all('route4').abortable(abortablePromiseList).put() => aborts all promises in abortablePromiseList, returns AbortablePromise
// etc. you get the picture
angular.module('aprima-legacy-common').run(['CustomModuleRunService', function(CustomModuleRunService) {
    'use strict';
    CustomModuleRunService.add(
    ['Restangular', '_', 'HttpAbortableContext', '$qHelpers', function(Restangular, _, HttpAbortableContext, $qHelpers) {

    var abortableFn = 'abortable';
    var abortsFn = 'aborts';
    var abortableFields = {};
    abortableFields[abortableFn] = abortableFn;
    abortableFields[abortsFn] = abortsFn;
    //add these as RestangularFields, so that way they will stripped out correctly when calling .plain()
    Restangular.setRestangularFields(abortableFields);
    Restangular.setOnElemRestangularized(makeElementRequestAbortable);

    function makeElementRequestAbortable(element, isCollection, route, restangularObject) {
        if(element && restangularObject.configuration.isRestangularized(element)) {
            // aborts passed in promises after sending out request
            element[abortsFn] = function(promisesToAbort) {
                wrapCallsToRestangularizedElement(this, function(promise) {
                    $qHelpers.abortPromises(promisesToAbort);
                    return promise;
                });
                return this;
            };

            // aborts passed in promises after sending out request, and returns an abortable promise
            element[abortableFn] = function(promisesToAbort) {
                var abortableContext = new HttpAbortableContext(promisesToAbort);
                var httpConfig = restangularObject.configuration.restangularFields.httpConfig;
        
                // withHttpConfig needs to be called before this, so it doesn't get overwritten
                this[httpConfig] = _.defaults(this[httpConfig], {timeout: abortableContext.abortPromise});
                wrapCallsToRestangularizedElement(this, abortableContext.wrap);
                return this;
            };
        }
        return element;
    }
    
    // ideally would use setRestangularizePromiseInterceptor instead of this but it doesn't expect a return value,
    // it only allows you to mutate the promise, not wrap it and return a new one like we are doing here
    function wrapCallsToRestangularizedElement(restangularizedElement, promiseInterceptor) {
        _(restangularizedElement)
            .functions()
            .forEach(function(key) {
                var elementFn = restangularizedElement[key];
                var wrappedKey = '_' + key;
                restangularizedElement[wrappedKey] = restangularizedElement[wrappedKey] || elementFn;

                restangularizedElement[key] = function() {
                    var result = elementFn.apply(this, arguments);

                    if ($qHelpers.isPromise(result)) {
                        result = promiseInterceptor(result);
                    }

                    return result;
                };
            });

        return restangularizedElement;
    }
    }]);
}]);
